import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { CorporateReportTypes } from '@reports/report-details/corporate/corporate-reports.enum';
import { QuarterRangeSelectorValue, QuarterSelectorType, QuarterSelectorValue } from '@cbre/components';
import { SharedService } from '@shared/services/shared.service';

import { InputProps } from '../input-props';

@Component({
  selector: 'miq-period-range',
  template: `
    <miq-filter-bar-label [props]="props"></miq-filter-bar-label>
    <cbre-miq-quarter-selector
      [value]="value"
      [type]="type"
      [showAsQtd]="true"
      [maxValue]="maxValue"
      [marketQtdVal]="marketQtdValue"
      (valueChange)="changeRange($event)"
    ></cbre-miq-quarter-selector>
  `,
  styleUrls: ['./period-range.component.scss'],
  standalone: false,
})
export class PeriodRangeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() value: QuarterRangeSelectorValue;
  @Input() props: InputProps;
  @Input() type: QuarterSelectorType;
  @Output() selection = new EventEmitter();
  @Input() marketQtd: number;
  @Input() maxValue: QuarterSelectorValue | Date;
  @Input() reportId: number;
  @Input() reportType?: string;

  constructor(private sharedService: SharedService) {}

  public today = new Date();

  public marketQtdValue: Date | QuarterSelectorValue = this.today;

  ngOnInit() {
    // required by language
  }

  ngOnChanges() {
    if (this.marketQtd && this.reportType === CorporateReportTypes.Corporate) {
      this.sharedService.getMarketQtd(this.marketQtd, this.reportId).subscribe(
        qtdValue => {
          this.marketQtdValue =
            qtdValue == 0 ? this.today : { periodYear: this.today.getFullYear(), periodValue: qtdValue };
        },
        () => (this.marketQtdValue = this.today)
      );
    }
  }

  ngOnDestroy() {
    // required by language
  }

  changeRange($event) {
    this.selection.emit({ [this.props.field]: $event });
  }
}
